"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCustoComponent = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("../components");
const hooks_1 = require("../../utils/hooks");
const hook_1 = require("../hook");
function buildCustoComponent(hook, path, defaultValue) {
    return react_1.default.forwardRef(function CustComponentWrapper(props, ref) {
        let val = hook();
        if (val === undefined && defaultValue !== undefined) {
            val = defaultValue;
        }
        const valRef = react_1.useRef(val);
        valRef.current = val;
        const dependency = val instanceof hook_1.CustoHook ? val.unsafelyGetOriginalFn() : null;
        const key = hooks_1.useVersion(dependency, val instanceof hook_1.CustoHook && val.isSafe);
        const componentRef = react_1.useRef();
        if (!componentRef.current) {
            function WrapperComponent(props, ref) {
                const val = valRef.current;
                let custComponent = val instanceof hook_1.CustoHook ? val.use(props) : val;
                if (!(custComponent instanceof components_1.CustoComponent)) {
                    const newVal = components_1.CustoComponent.create(val);
                    custComponent = newVal;
                }
                return custComponent.render(Object.assign(Object.assign({}, props), { ref }));
            }
            WrapperComponent.displayName = "CustoComp-" + path;
            componentRef.current = react_1.default.forwardRef(WrapperComponent);
        }
        const Component = componentRef.current;
        return react_1.default.createElement(Component, Object.assign({}, props, { ref: ref, key: key }));
    });
}
exports.buildCustoComponent = buildCustoComponent;
